import { IScenarioAssetMapping } from '../../interfaces/iscenario-asset-mapping';
import { Asset } from '../asset';
import { AssetType } from '../asset-type';
import { Scenario } from '../scenario';

export class ScenarioAssetMappingBase {
  ScenarioAssetMappingId: number;
  SourceAssetId: number | null;
  SourceAssetTypeId: number | null;
  TargetAssetId: number | null;
  TargetAssetTypeId: number | null;
  IsActive: boolean | null;
  ScenarioId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Scenario?: Scenario;
  SourceAsset?: Asset;
  SourceAssetType?: AssetType;
  TargetAsset?: Asset;
  TargetAssetType?: AssetType;

  constructor(item?: IScenarioAssetMapping) {
    if (item) {

      this.ScenarioAssetMappingId = item.ScenarioAssetMappingId;
      this.SourceAssetId = item.SourceAssetId;
      this.SourceAssetTypeId = item.SourceAssetTypeId;
      this.TargetAssetId = item.TargetAssetId;
      this.TargetAssetTypeId = item.TargetAssetTypeId;
      this.IsActive = item.IsActive;
      this.ScenarioId = item.ScenarioId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Scenario = new Scenario(item.Scenario);
      this.SourceAsset = new Asset(item.SourceAsset);
      this.SourceAssetType = new AssetType(item.SourceAssetType);
      this.TargetAsset = new Asset(item.TargetAsset);
      this.TargetAssetType = new AssetType(item.TargetAssetType);
    }
  }
}